import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.initializeAdsense()
  }

  initializeAdsense() {
    if (typeof window.adsbygoogle === 'undefined') {
      window.adsbygoogle = []
    }

    if (!window.adsbygoogle.loaded) {
      window.adsbygoogle.loaded = true
      window.adsbygoogle.push({})
    }
  }
}
